import 'htmx.org'

import * as hyperscript from 'hyperscript.org'

// Initialize hyperscript.
hyperscript.browserInit()

// Telegram Web App SDK
const tg = window.Telegram?.WebApp

if (tg) {
  // Инициализация Telegram Web App
  tg.ready()

  // Применяем тему Telegram
  tg.expand()

  // Устанавливаем цвета из темы Telegram
  if (tg.themeParams) {
    document.documentElement.style.setProperty('--tg-theme-bg-color', tg.themeParams.bg_color || '#ffffff')
    document.documentElement.style.setProperty('--tg-theme-text-color', tg.themeParams.text_color || '#000000')
    document.documentElement.style.setProperty('--tg-theme-hint-color', tg.themeParams.hint_color || '#999999')
    document.documentElement.style.setProperty('--tg-theme-link-color', tg.themeParams.link_color || '#2481cc')
    document.documentElement.style.setProperty('--tg-theme-button-color', tg.themeParams.button_color || '#2481cc')
    document.documentElement.style.setProperty('--tg-theme-button-text-color', tg.themeParams.button_text_color || '#ffffff')
    document.documentElement.style.setProperty('--tg-theme-secondary-bg-color', tg.themeParams.secondary_bg_color || '#f4f4f5')
  }

  // Функция для активации промпта
  window.activatePrompt = function(promptId, deepLink) {
    // Показываем уведомление
    tg.showAlert('Промпт активирован! Перейдите в бот для использования.')

    // Отправляем данные боту
    tg.sendData(JSON.stringify({
      action: 'activate_prompt',
      prompt_id: promptId
    }))

    // Опционально: закрываем Web App после активации
    // tg.close()
  }

  // Устанавливаем главную кнопку для страниц промптов
  window.setMainButton = function(text, promptId, deepLink) {
    tg.MainButton.setText(text)
    tg.MainButton.show()
    tg.MainButton.onClick(() => {
      window.activatePrompt(promptId, deepLink)
    })
  }

  // Скрыть главную кнопку
  window.hideMainButton = function() {
    tg.MainButton.hide()
  }

  console.log('Telegram Web App initialized', tg.initDataUnsafe)
} else {
  console.warn('Telegram Web App SDK not available')
}
